import { Popover } from '@mui/material';
import { defineds } from '../../constants/ui.constants';
import { useAppSelector } from '../../hooks/redux.hooks';
import { DateRangePicker, createStaticRanges } from 'react-date-range';
import { getMobile } from '../../state/reducers/ui.reducers';
import { CustomDateRangePicker } from '../../theme/elements/Inputs';
import React, { useState, useEffect } from 'react';

interface Props {
	id: any;
	showCalender: boolean;
	anchorEl: any;
	state: any;
	handleClose: any;
	onChange: any;
	isInFuture?: boolean;
}

export default function DateRangePopover(props: Props) {
	const sideBarOptions = () => {
		const customDateObjects = [
			{
				label: 'Last year',
				range: () => ({
					startDate: defineds.startOfLast365Day,
					endDate: defineds.endOfToday,
				}),
			},
			{
				label: 'Last quart',
				range: () => ({
					startDate: defineds.startOfLastNinetyDay,
					endDate: defineds.endOfToday,
				}),
			},
			{
				label: 'Last Month',
				range: () => ({
					startDate: defineds.startOfLastThirtyDay,
					endDate: defineds.endOfToday,
				}),
			},
			{
				label: 'Last Week',
				range: () => ({
					startDate: defineds.startOfLastSevenDay,
					endDate: defineds.endOfToday,
				}),
			},
			{
				label: 'Today',
				range: () => ({
					startDate: defineds.startOfToday,
					endDate: defineds.endOfToday,
				}),
			},
		];

		return customDateObjects;
	};

	const sideBar: any = sideBarOptions();
	const staticRanges = [
		// ...defaultStaticRanges,
		...createStaticRanges(sideBar),
	];
	const isMobile = useAppSelector(getMobile);

	return (
		<Popover
			id={props.id}
			open={props.showCalender}
			anchorEl={props.anchorEl}
			onClose={props.handleClose}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left',
			}}
		>
			<CustomDateRangePicker isInFuture={props.isInFuture}>
				<DateRangePicker
					minDate={
						props.isInFuture
							? new Date()
							: props.state[0]?.companyStartDate
							? new Date(props.state[0]?.companyStartDate)
							: undefined
					}
					maxDate={props.isInFuture ? undefined : new Date()}
					ranges={props.state}
					onChange={(item) => {
						props.onChange(item);
					}}
					// showSelectionPreview={true}
					moveRangeOnFirstSelection={false}
					months={2}
					direction={isMobile ? 'vertical' : 'horizontal'}
					staticRanges={staticRanges}
				/>
			</CustomDateRangePicker>
		</Popover>
	);
}
